<template lang="html">
  <div>
    <noscript>
      <iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-WX9QHHQX"
      height="0"
      width="0"
      style="display:none;visibility:hidden">
      </iframe>
    </noscript>
    <h3>Vamos criar a sua conta!</h3>
    <p>Informe seus dados abaixo e confirme seu email para ter acesso a todos nossos recursos e facilidades.</p>
    <p>
      Está com dúvidas? Assista ao nosso tutorial de primeiros passos
      <a
        href="#"
        @click.prevent="openTutorial"
        class="link">clicando aqui</a>.
    </p>
    <form
      ref="signupForm"
      @submit.prevent="onSubmit"
      @keydown.enter.prevent="onSubmit">
      <div
        v-if="error"
        class="alert alert-danger"
        role="alert">
        {{ error.message }}
      </div>
      <div
        class="form-group"
        title="Informe o nome da empresa ou como gostaria de ser chamado?"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-home" />
          </div>
          <input
            type="text"
            class="form-control"
            ref="organizationName"
            placeholder="Nome da empresa"
            maxlength="128"
            v-model="organizationName"
            required
            autofocus>
        </div>
      </div>
      <div
        class="form-group"
        title="Informe um domínio para acessar seu Webphone"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-globe" />
          </div>
          <input
            type="text"
            class="form-control"
            ref="domain"
            placeholder="Domínio"
            maxlength="50"
            v-model="domain"
            required>
          <div class="input-group-append">
            <span class="input-group-text">.api4com.com</span>
          </div>
        </div>
      </div>
      <div
        class="form-group"
        title="Declare seu melhor email, esta conta será verificada"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-mail" />
          </div>
          <input
            type="email"
            class="form-control"
            placeholder="Email"
            maxlength="128"
            v-model="email"
            required>
        </div>
      </div>
      <div
        class="form-group"
        title="Importante criar uma senha forte, contendo letras minúsculas e maiúsculas, números e caracteres especiais"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-lock" />
          </div>
          <input
            type="password"
            class="form-control"
            placeholder="Senha"
            maxlength="128"
            v-model="password"
            required>
        </div>
      </div>
      <div
        class="form-group"
        title="Informe a mesma senha"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-eye-off" />
          </div>
          <input
            type="password"
            class="form-control"
            placeholder="Confirme a senha"
            maxlength="128"
            v-model="confirmPassword"
            required>
        </div>
      </div>
      <div
        class="form-group"
        title="Insira seu melhor telefone de contato"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-phone" />
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Telefone"
            maxlength="25"
            v-model="phone"
            required>
        </div>
      </div>
      <div
        class="form-group"
        title="Escolha um CRM caso utilize, senão selecione Outros"
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-users" />
          </div>
          <select
            class="custom-select custom-select-sm form-control form-control-sm"
            id="crm"
            v-model="crm"
            required>
            <option
              value="null"
              disabled>
              Utiliza qual CRM?
            </option>
            <option
              v-for="option in crmOptions"
              :key="option.value"
              :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="form-group"
        title="Selecione a média de usuários que utilizam telefone na sua operação."
        data-toggle="tooltip"
        data-placement="top">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-user-plus" />
          </div>
          <select
            class="custom-select custom-select-sm form-control form-control-sm"
            id="userQuantity"
            v-model="userQuantity"
            required>
            <option
              value="null"
              disabled>
              Quantos usuários utilizam o telefone na sua operação?
            </option>
            <option
              v-for="option in userQuantityOptions"
              :key="option.value"
              :value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="buttons">
        <button
          class="btn btn-outline-secondary"
          @click.prevent="onCancel">Cancelar</button>
        <button
          type="submit"
          ref="submitButton"
          class="btn btn-primary">Criar conta</button>
      </div>
    </form>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="signupSuccess"
      ref="signupSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sua conta foi criada com sucesso!</h5>
            <button
              type="button"
              class="close"
              @click.prevent="onModalOk"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="alert alert-warning">Porém ainda temos mais um passo para finalizar o cadastro, por favor verifique seu e-mail e clique no link de verificação antes de fazer o seu primeiro login.</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click.prevent="onModalOk">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialSignup"
      ref="tutorialSignup"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Signup</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/oBHsmgYi6q8"
              title="Tutorial Signup"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const RESERVED_DOMAINS = [
  'app',
  'api',
  'api2',
  'blog',
  'database-replication',
  'developers',
  'docs',
  'fs',
  'fs1',
  'fs2',
  'fs3',
  'fs4',
  'fs5',
  'fs6',
  'balancer',
  'ssw',
  'status',
  'uptime1',
  'www'
]
export default {
  name: 'OrganizationSignup',
  data () {
    return {
      organizationName: null,
      email: null,
      password: null,
      confirmPassword: null,
      domain: null,
      phone: null,
      crm: null,
      crmOptions: [
        {text: 'ActiveCampaign', value: 'ActiveCampaign'},
        {text: 'Agendor CRM', value: 'Agendor'},
        {text: 'AppFacilita', value: 'AppFacilita'},
        {text: 'DAVOS CRM', value: 'DavosCRM'},
        {text: 'Exact Sales', value: 'ExactSalesSpotter'},
        {text: 'Groner', value: 'Groner'},
        {text: 'HubSpot', value: 'HubSpot'},
        {text: 'Kommo', value: 'Kommo'},
        {text: 'Moskit', value: 'MoskitCRM'},
        {text: 'Nectar', value: 'NectarCRM'},
        {text: 'Pipedrive', value: 'Pipedrive'},
        {text: 'Piperun', value: 'Piperun'},
        {text: 'Ploomes', value: 'Ploomes'},
        {text: 'RD Station CRM', value: 'RDCRM'},
        {text: 'Salesflow', value: 'Salesflow'},
        {text: 'Salesforce', value: 'Salesforce'},
        {text: 'SharpSpring', value: 'SharpSpring'},
        {text: 'Zendesk', value: 'Zendesk'},
        {text: 'Zoho', value: 'ZohoCRM'},
        {text: 'Outros', value: 'Outros'}
      ],
      voucherCode: this.$route.query.voucher,
      error: null,
      userQuantity: null,
      userQuantityOptions: [
        {text: 'Entre 01 e 03 pessoas', value: '1-3'},
        {text: 'Entre 04 e 10 pessoas', value: '4-10'},
        {text: 'Entre 11 e 20 pessoas', value: '11-20'},
        {text: 'Mais de 21 pessoas', value: '21+'}
      ]
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      this.addGoogleTag()
    })
  },
  methods: {
    addGoogleTag () {
      if (!document.getElementById('google-tag-manager')) {
        let script = document.createElement('script')
        script.id = 'google-tag-manager'
        script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-WX9QHHQX');
        `
        document.head.appendChild(script)
      }
    },
    onSubmit () {
      const form = this.$refs.signupForm
      this.error = null
      if (this.password === this.confirmPassword) {
        if (form.checkValidity()) {
          if (RESERVED_DOMAINS.includes(this.domain)) {
            this.error = { message: 'Domínio inválido, por favor informe outro' }
            return
          }
          this.$refs.submitButton.disabled = true
          setTimeout(_ => {
            this.$refs.submitButton.disabled = false
          }, 5000)
          const payload = {
            organizationName: this.organizationName,
            domain: `${this.domain}.api4com.com`,
            password: this.password,
            email: this.email,
            phone: this.phone,
            crm: this.crm,
            voucherCode: this.voucherCode,
            redirect: this.$route.params.redirect,
            userQuantity: this.userQuantity
          }
          const campaignId = this.getQueryParamCaseInsensitive(this.$route.query, 'campaignId')
          if (campaignId) {
            payload.campaignId = campaignId
          }
          this
            .$store
            .dispatch('auth/signUp', payload)
            .then(_ => {
              $(this.$refs.signupSuccess).modal('show')
            })
            .catch(err => {
              this.parseError(err, errorMessage => {
                this.error = { message: errorMessage }
              })
            })
        } else {
          this.error = { message: 'Por favor, informe todos os campos' }
        }
      } else {
        this.error = { message: 'A senha e confirmação não conferem, favor informar a mesma senha' }
      }
    },
    getQueryParamCaseInsensitive (query, param) {
      const lowerParam = param.toLowerCase()
      const matchingKeys = Object.keys(query).filter(k => k.toLowerCase() === lowerParam)
      return matchingKeys.length > 0 ? query[matchingKeys[0]] : null
    },
    parseError (error, cb) {
      let errorMessage = 'Oops! Ocorreu algo inesperado :( porfavor entre em contato com suporte@api4com.com'
      if (error) {
        if (error.message) errorMessage = error.message
        if (error.statusCode && error.statusCode === 422) errorMessage = error.message
        if (error.details) {
          if (error.details.codes) {
            if (error.details.codes.phone && error.details.codes.phone[0] === 'invalid') errorMessage = 'O número informado não é válido, por favor verifique se possui DDD (2 dígitos) + Número (8 ou 9 dígitos) e tente novamente'
            if (error.details.codes.domain && error.details.codes.domain[0] === 'uniqueness') errorMessage = 'Domínio já cadastrado, por favor informe outro'
            if (error.details.codes.email && error.details.codes.email[0] === 'uniqueness') errorMessage = 'Email já cadastrado, por favor informe outro ou recupere a senha'
          }
        }
        if (error.message === 'invalid email') errorMessage = 'Email inválido, por favor informe um email válido'
      }
      cb(errorMessage)
    },
    onModalOk () {
      $(this.$refs.signupSuccess).modal('hide')
      this.$router.push(this.$route.params.redirect || {name: 'login'})
    },
    onCancel () {
      this.$router.go(-1)
    },
    openTutorial () {
      $(this.$refs.tutorialSignup).modal('show')
    }
  },
  watch: {
    email: function (value) {
      this.email = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
    },
    domain: function (value) {
      this.domain = value.replace(/[^A-Za-z0-9]/, '').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.signup {
  display: flex;
  height: 100vh;
}
.card {
  margin: auto;
  max-width: 650px;
}
.custom-select {
  color: #818b91;
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/Signup.vue